export interface ProductoTipoBItem {
  id: number;
  numeroDerc?: string;
  numeroGuiaProduccion: number;
  codigoArticulo?: string;
  descripcionArticulo?: string;
  presentacion?: string;
  calibre?: string;
  pesoEmpaqueInterior: number;
  cantidadTotal: number;
  cantidadUsada: number;
  cantidadDisponible: number;
  pesoTotal: number;
  pesoUsado: number;
  pesoDisponible: number;
}

export interface ProductoTipoBResumen {
  totalItems: number;
  pesoTotalProducto: number;
  pesoTotalUsado: number;
  pesoTotalDisponible: number;
}

export interface ProductoTipoBReport {
  items: ProductoTipoBItem[];
  resumen: ProductoTipoBResumen;
}

export type EstadoProductoB = 'Disponible' | 'Parcial' | 'Consumido';

export const getEstadoProductoB = (item: ProductoTipoBItem): EstadoProductoB => {
  if (item.cantidadUsada <= 0) return 'Disponible';
  if (item.cantidadUsada >= item.cantidadTotal) return 'Consumido';
  return 'Parcial';
};
